import PlanYear from 'model/PlanYear';
import PlansForDate from 'modules/effectiveDate/types';

// Plan year dates come back as plain dates, sometimes with a time part. Only
// the calendar day counts, so compare the first ten characters as text and
// never go through `new Date(iso)`, which shifts the day by time zone.
const dayOf = (value: string) => value.slice(0, 10);

export const coversDate = (planYear: PlanYear, date: string) =>
  dayOf(planYear.startDate) <= dayOf(date) &&
  (!planYear.endDate || dayOf(date) <= dayOf(planYear.endDate));

// The plan year the server uses as the guide's own plan year for a date: the
// newest start among those that cover it, lowest id on a tie.
export const pickupPlanYear = (planYears: PlanYear[], date: string) =>
  planYears
    .filter((planYear) => coversDate(planYear, date))
    .sort(
      (a, b) =>
        dayOf(b.startDate).localeCompare(dayOf(a.startDate)) ||
        a.id.localeCompare(b.id)
    )[0];

// Classes belong to the guide's existing years and every year covering its date.
export const classOptionsFor = (
  planYears: PlanYear[],
  guidePlanYearIds: string[],
  date: string
) => {
  const relevant = planYears.filter(
    (planYear) =>
      guidePlanYearIds.includes(planYear.id) || coversDate(planYear, date)
  );
  return Array.from(
    new Set(relevant.flatMap((planYear) => planYear.benefitGroups))
  );
};

// The years the plan lists really draw from on this date: plans-for-date
// already drops an older open-ended year once a newer one serves the line,
// which coversDate does not. Oldest start first, one entry per year.
export const coveringPlanYearNames = (plansForDate: PlansForDate) => {
  const byId = new Map(
    plansForDate.lines
      .flatMap((line) => line.planYears)
      .map((planYear) => [planYear.id, planYear])
  );
  return Array.from(byId.values())
    .sort(
      (a, b) =>
        dayOf(a.startDate).localeCompare(dayOf(b.startDate)) ||
        a.id.localeCompare(b.id)
    )
    .map((planYear) => planYear.name);
};
